type PaymentFormData = {
    paymentUrl: string;
    form: Record<string, string | number>;
};

export const submitPaymentForm = ({ paymentUrl, form }: PaymentFormData) => {
    const formEl = document.createElement('form');
    formEl.method = 'POST';
    formEl.action = paymentUrl;

    Object.entries(form).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = String(value);
        formEl.appendChild(input);
    });

    document.body.appendChild(formEl);
    formEl.submit();
};
